<div class="overlay" (click)="toggleModal()"></div>
<div class="container flex-column m-0 p-0 d-flex">
    <div class="row g-0 m-0 p-4 justify-content-start borderb">
        <div class="col-md-11 ps-2 d-flex justify-content-start">
            <span class="popup-title">{{ "MONITORING_DEVICECONNECTION" | translate }} {{ "DETAILS" | translate }}</span>
        </div>
        <div class="col-md-1 d-flex justify-content-end" (click)="toggleModal()">
            <svg-icon alt="Exit" class="exit" role="button" src="assets/device/exit.svg"></svg-icon>
        </div>
    </div>
    <div class="row g-0 m-0 body">
        <div class="row g-0 m-0 pt-3">
            <div class="col-md-6 d-flex justify-content-start">
                <span class="item-name">{{ "DEVICESETUP_METERNO" | translate }}</span>
            </div>
            <div class="col-md-6 d-flex justify-content-start">
                <span class="item-info">{{ devieConnection.meterNumber ? devieConnection.meterNumber : "/" }}</span>
            </div>
        </div>
        <div class="row g-0 m-0">
            <div class="col-md-6 d-flex justify-content-start">
                <span class="item-name">{{ "DEVICESETUP_METERMAKE" | translate }}</span>
            </div>
            <div class="col-md-6 d-flex justify-content-start">
                <span class="item-info">{{ devieConnection.meterMake ? devieConnection.meterMake : "/" }}</span>
            </div>
        </div>
        <div class="row g-0 m-0">
            <div class="col-md-6 d-flex justify-content-start">
                <span class="item-name">{{ "SESSIONSTATUS" | translate }}</span>
            </div>
            <div class="col-md-6 d-flex justify-content-start align-items-start pt-3">
                <span class="item-info pt-1 pb-1"
                    [ngClass]="devieConnection.sessionStatus ? 'status-completed' : 'status-failed'">{{
                    devieConnection.sessionStatus ? "On" : "Off" }}</span>
            </div>
        </div>
        <div class="row g-0 m-0">
            <div class="col-md-6 d-flex justify-content-start">
                <span class="item-name">{{ "SIMCARDNUMBER" | translate }}</span>
            </div>
            <div class="col-md-6 d-flex justify-content-start">
                <span class="item-info">{{ devieConnection.simCardNumber ? devieConnection.simCardNumber : "/" }}</span>
            </div>
        </div>
        <div class="row g-0 m-0">
            <div class="col-md-6 d-flex justify-content-start">
                <span class="item-name">{{ "INSTALLATIONDATE" | translate }}</span>
            </div>
            <div class="col-md-6 d-flex justify-content-start">
                <span class="item-info">{{
                    devieConnection.dateInstalled ? (devieConnection.dateInstalled | date: "dd MMM yyyy, h:mm a") : "/"
                }}</span>
            </div>
        </div>
        <div class="row g-0 m-0">
            <div class="col-md-6 d-flex justify-content-start">
                <span class="item-name">{{ "LATESTCONN" | translate }}</span>
            </div>
            <div class="col-md-6 d-flex justify-content-start">
                <span class="item-info">{{
                    devieConnection.latestConnection ? (devieConnection.latestConnection | date: "dd MMM yyyy, h:mm a") : "/"
                }}</span>
            </div>
        </div>
    </div>
    <div class="row g-0 m-0 p-3 align-items-end bordert">
        <div class="col-md-9 pt-2 pb-2 ps-2 d-flex justify-content-start" (click)="toggleModal()">
            <span role="button" class="item-name">{{ "CLOSE_WINDOW" | translate }}</span>
        </div>
    </div>
</div>
